import { useContext, useEffect } from "react";
import {ConfigContext} from './ConfigContext';

const HeadConfig = () => {
  const config = useContext(ConfigContext);

  useEffect(() => {
    if (!config) return;

    // Update favicon
    if (config?.icons?.favicon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = config?.icons.favicon;

      document.getElementsByTagName("head")[0].appendChild(link);
    }
  }, [config]);

  return null; // no UI
};

export default HeadConfig;